import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=4f5756c3&"
import script from "./CustomFields.vue?vue&type=script&lang=js&"
export * from "./CustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5756c3')) {
      api.createRecord('4f5756c3', component.options)
    } else {
      api.reload('4f5756c3', component.options)
    }
    module.hot.accept("./CustomFields.vue?vue&type=template&id=4f5756c3&", function () {
      api.rerender('4f5756c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/dashboard/CustomFields.vue"
export default component.exports